import type { LucideProps } from 'lucide-react';

interface StackedIconProps {
  /** Lucide icon component to display on the front square */
  icon: React.ComponentType<LucideProps>;
}

/**
 * Decorative stacked icon with three overlapping rounded squares.
 * Used in empty state cards to provide a visual accent.
 */
export const StackedIcon = ({ icon: IconComponent }: StackedIconProps) => {
  return (
    <div
      className="flex items-center pr-[1.875rem]"
      data-component="StackedIcon"
      data-testid="stacked-icon"
    >
      <div className="mr-[-1.875rem] size-10 shrink-0 rounded-md bg-ckds-neutral-800" />
      <div className="mr-[-1.875rem] size-10 shrink-0 rounded-md bg-ckds-neutral-700" />
      <div className="mr-[-1.875rem] flex size-10 shrink-0 items-center justify-center rounded-md bg-ckds-neutral-500">
        <IconComponent className="glyph glyph-lg text-white" aria-hidden="true" />
      </div>
    </div>
  );
};
